export var HotelServiceActionTypes;
(function (HotelServiceActionTypes) {
    HotelServiceActionTypes["RECEIVE_HOTEL_FORM_DATA_RESPONSE"] = "RECEIVE_HOTEL_FORM_DATA_RESPONSE";
    HotelServiceActionTypes["RECEIVE_HOTEL_GROUPS_RESPONSE"] = "RECEIVE_HOTEL_GROUPS_RESPONSE";
    HotelServiceActionTypes["RECEIVE_HOTEL_OFFERS_RESPONSE"] = "RECEIVE_HOTEL_OFFERS_RESPONSE";
    HotelServiceActionTypes["RECEIVE_HOTEL_PRODUCTS_RESPONSE"] = "RECEIVE_HOTEL_PRODUCTS_RESPONSE";
    HotelServiceActionTypes["RECEIVE_HOTEL_VARIANTS_RESPONSE"] = "RECEIVE_HOTEL_VARIANTS_RESPONSE";
    HotelServiceActionTypes["RECEIVE_HOTEL_SUGGESTIONS_RESPONSE"] = "RECEIVE_HOTEL_SUGGESTIONS_RESPONSE";
    HotelServiceActionTypes["RECEIVE_HOTEL_QUERY_OPTIONS"] = "RECEIVE_HOTEL_QUERY_OPTIONS";
    HotelServiceActionTypes["RECEIVE_HOTEL_GROUP_QUERY_OPTIONS"] = "RECEIVE_HOTEL_GROUP_QUERY_OPTIONS";
    HotelServiceActionTypes["REQUEST_HOTEL_FORM_DATA"] = "REQUEST_HOTEL_FORM_DATA";
    HotelServiceActionTypes["REQUEST_HOTEL_GROUPS"] = "REQUEST_HOTEL_GROUPS";
    HotelServiceActionTypes["REQUEST_HOTEL_OFFERS"] = "REQUEST_HOTEL_OFFERS";
    HotelServiceActionTypes["REQUEST_MORE_HOTEL_OFFERS"] = "REQUEST_MORE_HOTEL_OFFERS";
    HotelServiceActionTypes["REQUEST_HOTEL_PRODUCTS"] = "REQUEST_HOTEL_PRODUCTS";
    HotelServiceActionTypes["REQUEST_HOTEL_SUGGESTIONS"] = "REQUEST_HOTEL_SUGGESTIONS";
    HotelServiceActionTypes["REQUEST_MORE_HOTEL_PRODUCTS"] = "REQUEST_MORE_HOTEL_PRODUCTS";
    HotelServiceActionTypes["REQUEST_HOTEL_VARIANTS"] = "REQUEST_HOTEL_VARIANTS";
    HotelServiceActionTypes["REQUEST_HOTEL_QUERY_OPTIONS"] = "REQUEST_HOTEL_QUERY_OPTIONS";
    HotelServiceActionTypes["REQUEST_HOTEL_GROUP_QUERY_OPTIONS"] = "REQUEST_HOTEL_GROUP_QUERY_OPTIONS";
})(HotelServiceActionTypes || (HotelServiceActionTypes = {}));
